<template>
  <h1>
   Hello Authenticated
  </h1>
 </template>
 
 <script>
//  import { onMounted } from 'vue';
// import VueCookies from 'vue-cookies'

// import Cookies from 'cookies';

 export default {
   name: 'UserSpace',
   props: {
     msg: String
   },
   mounted() {
    // const $cookies = inject<VueCookies>('$cookies'); 
    // alert($cookies.get("ttp"));
    // alert(VueCookies.get("ttp"));
    // VueCookies.set("token-type", "Bearer");
    // alert('1')

   }
 }
 
 </script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
 h3 {
   margin: 40px 0 0;
 }
 ul {
   list-style-type: none;
   padding: 0;
 }
 li {
   display: inline-block;
   margin: 0 10px;
 }
 a {
   color: #42b983;
 }
 </style>